import { render, staticRenderFns } from "./Domestic.vue?vue&type=template&id=2f73c37a"
import script from "./Domestic.vue?vue&type=script&lang=js"
export * from "./Domestic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports